import * as moment from 'moment';
import 'moment-timezone';
import * as React from 'react';
import DatePicker from 'react-date-picker';
export interface IDatePickerProps {
    value: any;
    format?: string;
    onChange: Function;
}

export class RDatePicker extends React.PureComponent<IDatePickerProps, {}> {
    constructor(props: IDatePickerProps) {
        super(props);
    }

    handleChange = (date) => {
        const { format, onChange } = this.props;
        const newDate = format ? moment(date).format(format) :
        // const newDate = format ? moment(date).tz('America/Chicago').format(format) :
            moment(date).toDate();
            // moment(date).tz('America/Chicago').toDate();
        onChange(newDate);
    }

    render() {
        const { value } = this.props;
        return (
            <DatePicker
                value={value}
                onChange={this.handleChange}
                locale="en-US"
                maxDate={new Date()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/DatePicker.tsx